import { Popover, List } from 'antd';
import { MobileOutlined } from '@ant-design/icons';
import { UserDeviceDTO } from '../api';
import { useMemo } from 'react';

const rootMobile = 'OnePlus Ace 5 Race';

export default function UserDevice({ devices }: { devices?: UserDeviceDTO[] }) {
  const hasRootMobile = devices?.some(
    (device) => device.mobileMode === rootMobile,
  );
  // 如果 devices 是空,返回 null
  if (!devices || devices.length === 0 || !hasRootMobile) {
    return null;
  }

  // 按最后登录时间取最新的一条设备
  const latestDevice = devices.reduce((latest, device) =>
    (device.updatedAt || '') > (latest.updatedAt || '') ? device : latest,
  );

  // 最新一条是已授权的监控手机时，列表图标不标红
  const latestIsAuthorizedMonitor =
    latestDevice.mobileMode === rootMobile && !!latestDevice.rooted;

  // 判断是否有任何一个设备 rooted 为 false (0)
  const hasUnrooted =
    !latestIsAuthorizedMonitor &&
    devices.some(
      (device) => device.mobileMode === rootMobile && !device.rooted,
    );

  // 获取手机型号显示文本
  const getMobileModeName = (mobileMode?: string) => {
    if (mobileMode === rootMobile) {
      return '监控手机';
    }
    return mobileMode || '-';
  };

  // 弹出内容
  const content = (
    <div style={{ minWidth: 400 }}>
      <List
        size="small"
        dataSource={devices}
        renderItem={(device) => {
          const isUnrooted = !device.rooted;
          return (
            <List.Item style={{ color: isUnrooted ? 'red' : undefined }}>
              <List.Item.Meta
                title={
                  <div style={{ wordBreak: 'break-all' }}>
                    {device.deviceId || '未知设备'}
                  </div>
                }
                description={
                  <div>
                    <div>型号: {getMobileModeName(device.mobileMode)}</div>
                    <div>版本: {device.appVersion || '-'}</div>
                    <div>
                      微信监控:{' '}
                      {device.rooted ? (
                        '已授权'
                      ) : (
                        <span style={{ color: 'red' }}>未授权</span>
                      )}
                    </div>
                    <div>最后登录: {device.updatedAt || '-'}</div>
                  </div>
                }
              />
            </List.Item>
          );
        }}
      />
    </div>
  );

  return (
    <Popover content={content} title="设备信息" trigger="hover">
      <MobileOutlined
        style={{ color: hasUnrooted ? 'red' : undefined, cursor: 'pointer' }}
      />
    </Popover>
  );
}
